import { styled } from 'linaria/react';

export const StyledSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 96px;
  padding-bottom: 48px;
`;
